/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import { Module
    //, Node
 } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { IProductSearchViewProps } from './product-search';


const ProductSearchView: React.FC<IProductSearchViewProps> = ({
    moduleProps,
    productFilters,
    productResults

}) => {
    return (
        <Module {...moduleProps}>
           {productFilters}
            <div className="ms-search-result-container">
                <div className="ms-search-result-container__Products">
                    {productResults}
                </div>
            </div>
        </Module>
    );
};

export default ProductSearchView;